import { Component } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import { postData, updateData } from './constants.js';
const moment = require('moment');

class FeeHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      show: false,
      total: 0
    };
    this.goToPayment = this.goToPayment.bind(this);
    this.viewPaymentDetails = this.viewPaymentDetails.bind(this);
    this.handlePayment = this.handlePayment.bind(this);

  }

  async getFeePaymentHistory() {
    try {
      const response = await fetch('/api/fee_payment_history');
      const json = await response.json();
      console.log("json", json);  
      var total = json.filter((e) => e.is_paid === 0).reduce((total, item) => {
        total += item.price;
        return total;
      }, 0);

      console.log("total", total);

      this.setState({
        data: json.map((e) => {
          if (e.is_paid === 0) {
            e.added = true;
          } else {
            e.added = false;
          }
          return e;
        }), total
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getFeePaymentHistory();
    // if(this.props.feeDetailId && this.props.feeStatus){
    //   var data = { status :this.props.feeStatus }
    //   updateData('/api/fee_payment_status/'+this.props.feeDetailId, data).then((response) => {
    //       this.getFeePaymentHistory();
    //   });
    // }else{
    //   this.getFeePaymentHistory();
    // }
  }

  viewPaymentDetails(e) {
    const Id = parseInt(e.target.id);
    var paymentDetails = this.state.data.filter(e => e.id === Id)[0];
    this.setState(paymentDetails);
    this.setState({ show: true });
  }

  goToPayment(event) {
    event.preventDefault();
    const Id = parseInt(event.target.id);
    var paymentDetails = this.state.data.filter(e => e.id === Id)[0];
    var data = {
      host: window.location.hostname,
      protocol: window.location.protocol,
      origin: window.location.origin,
      fee_id: paymentDetails.fee_id,
      name: paymentDetails.name
    }
    postData('/api/create-checkout-session/' + Id, data).then((response) => {
      window.location = response.url;
    });
  }

  handlePayment() { 
    const fees = this.state.data.filter((e)=>e.added);
    console.log("fees", fees);
    var data = {
      host: window.location.hostname,
      protocol: window.location.protocol,
      origin: window.location.origin,
      fees: fees,
      name: "HOA Fee"
    }
    console.log("data", data)
    postData('/api/create-checkout-session', data).then((response) => {
      window.location = response.url;
    });
  }

  render() {
    const fee_payment_list = this.state.data.map((item) =>
      <tr key={item.id} id={item.id}>
        {/* <td>{moment(item.created_date).format("l")}</td> */}
        <td>{item.name}</td>
        <td>{item.lot_no}</td>
        <td>{item.wo_street_address}</td>
        <td>$ {item.price}</td>
        {/* <td className={item.is_paid ? 'text-success fw-bold' : 'fw-bold'}>{item.is_paid ? 'Paid' : 'Not paid'}</td> */}
        <td>
          {item.is_paid ? (
            <span>Paid
              <i id={item.id} className="fas fa-info-circle text-info action-icons" onClick={this.viewPaymentDetails}></i>
            </span>
          ) : (
            <div>
              <span>Not Paid</span>
              <span className="text-primary">  **</span>
            </div>
          )
          }
        </td>

      </tr>
    );

    return (
      <>

        {!this.state.show ? (
          <div className="card shadow-sm mb-2">
            <div className="card-header py-3">
              <h4 className="m-0 text-light fw-bold"> Fee Payments list</h4>
            </div>
            <div className="card-body">

              <div className="table-responsive fee-payments-table">
                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                  <thead>
                    <tr>
                      {/* <th>Pay Date</th> */}
                      <th>Fee Plan</th>
                      <th>Lot No.</th>
                      <th>W.O. Address</th>
                      <th>Price</th>
                      <th>Payment Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fee_payment_list}
                    <tr>
                      <td colSpan="3"><strong>Total</strong></td>
                      <td>$ {this.state.total}</td>
                      <td>
                        <button className={this.state.total>0?"btn btn-bg-success":"btn btn-secondary text-light "} 
                          onClick={this.handlePayment}
                          disabled={this.state.total <= 0}
                          > 
                          <i className="fa-solid fa-cart-shopping"></i>Checkout
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-2">
                <span className="text-primary float-right">** For owners who paid by check: payment status will be updated at month-end</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h4 className="m-0 font-weight-bold text-white">Fee Payment details</h4>
                </div>
                <div className="card-body event-view">
                  <div className="row my-2">
                    <div className="col-md-3">
                      <span>Fee Plan</span>
                    </div>
                    <div className="col-md-9">
                      <span className="font-weight-bold text-dark"> {this.state.name} </span>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-3">
                      <span>Price </span>
                    </div>
                    <div className="col-md-9">
                      <span className="font-weight-bold text-dark"> $ {this.state.price} </span>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-3">
                      <span> Payment Status </span>
                    </div>
                    <div className="col-md-9">
                      <span className="fw-bold text-success"> {this.state.is_paid ? 'Paid' : 'Not Paid'} </span>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-3">
                      <span>Payment Date </span>
                    </div>
                    <div className="col-md-9">
                      <span className="font-weight-bold text-dark"> {this.state.transaction_date ? moment(this.state.transaction_date).format('LLL') : ''} </span>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-3">
                      <span>Payment Transaction Ref </span>
                    </div>
                    <div className="col-md-9">
                      <span className="font-weight-bold text-dark"> {this.state.transaction_id} </span>
                    </div>
                  </div>
                  <div className="mt-2">
                    <button className="btn btn-sm btn-outline-secondary ms-2" onClick={() => this.setState({ show: false })}> Close </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

function Fee() {
  const [searchParams, setSearchParams] = useSearchParams();
  var feeStatus = searchParams.get("status");
  var feeDetailId = searchParams.get("id");
  return (
    <div id="wrapper">
      <SideNav />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <TopBar />
          <div className="container-fluid">
            <FeeHistory feeStatus={feeStatus} feeDetailId={feeDetailId} />
          </div>
        </div>
        <Footer />
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </div>
  );
}

export { Fee };
